import { render, staticRenderFns } from "./index.vue?vue&type=template&id=fa3e13ba&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "../../../../styles/button.less?vue&type=style&index=0&id=fa3e13ba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa3e13ba",
  null
  
)

export default component.exports